const envUrl = process.env.REACT_APP_BACKEND_URL;

// On the live custom domain, always call the API on the same origin the visitor
// is on (www vs apex safe). In preview, use the configured backend URL.
export const BACKEND_URL =
  typeof window !== "undefined" && window.location.hostname.endsWith("maisoncore.nl")
    ? window.location.origin
    : envUrl;

export const API = `${BACKEND_URL}/api`;
